import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Star } from 'lucide-react';
import { API, BACKEND_URL, fallbackTestimonials } from '@/constants/data';

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  useEffect(() => { axios.get(`${API}/testimonials`).then(r => setTestimonials(r.data)).catch(console.error); }, []);

  const displayTestimonials = testimonials.length > 0 ? testimonials : fallbackTestimonials;

  return (
    <section id="depoimentos" className="py-16 sm:py-20 lg:py-28 bg-[#0A2463] relative overflow-hidden" data-testid="testimonials-section">
      <div className="absolute inset-0">
        <img src="https://customer-assets.emergentagent.com/job_tomaselli-upgrade/artifacts/2f8eevct_image.png" alt="" className="w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-[#0A2463]/70" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="text-center mb-10 sm:mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white uppercase">Depoimentos</h2>
          <p className="text-white/60 text-sm sm:text-base lg:text-lg font-body mt-3">O que nossos clientes dizem</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8">
          {displayTestimonials.map((t, i) => (
            <motion.div key={t.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.15 }}
              data-testid={`testimonial-card-${i}`}
              className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-5 sm:p-8">
              <div className="flex gap-1 mb-3 sm:mb-5">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-yellow-400 text-yellow-400" />)}
              </div>
              <p className="text-white/80 font-body text-sm sm:text-base leading-relaxed mb-4 sm:mb-6">"{t.content}"</p>
              <div className="flex items-center gap-3 sm:gap-4">
                {t.image_url ? (
                  <img src={t.image_url.startsWith('/') ? `${BACKEND_URL}${t.image_url}` : t.image_url}
                    alt={t.name} className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover flex-shrink-0 border-2 border-white/20" />
                ) : (
                  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-[#00A8E8] flex items-center justify-center text-white font-heading text-lg sm:text-xl flex-shrink-0">
                    {t.name.charAt(0)}
                  </div>
                )}
                <div>
                  <p className="text-white font-bold font-body text-sm sm:text-base">{t.name}</p>
                  <p className="text-white/50 text-xs sm:text-sm font-body">{t.company}</p>
                  {t.source && <p className="text-[#5BC0F8] text-xs font-body mt-0.5">{t.source}</p>}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
